import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import UploadManager from './UploadManager';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    mutate: () => void;
}

export default function ModalUpload ({
    modal,
    setModal,
    mutate
}: Props) {

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Upload Manager</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <UploadManager mutate={mutate} />
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;